import React from "react";

const LocationStatus = ({
  activeTab,
  userLocation,
  locationError,
  isGettingLocation,
  nearbyRadius,
  onEnableLocation
}) => {
  // Only show for Map tab
  if (activeTab !== "map") {
    return null;
  }

  // Determine status type and styling
  const getStatusConfig = () => {
    if (isGettingLocation) {
      return {
        bgColor: "rgba(251, 191, 36, 0.1)",
        borderColor: "rgba(251, 191, 36, 0.3)",
        textColor: "#F59E0B",
        icon: "📍",
        message: "Getting your location..."
      };
    }
    
    if (userLocation) {
      return {
        bgColor: "rgba(34, 197, 94, 0.1)",
        borderColor: "rgba(34, 197, 94, 0.3)",
        textColor: "#059669",
        icon: "✅",
        message: `Location detected - Showing doctors within ${nearbyRadius}km`
      };
    }
    
    if (locationError) {
      return {
        bgColor: "rgba(239, 68, 68, 0.1)",
        borderColor: "rgba(239, 68, 68, 0.3)",
        textColor: "#DC2626",
        icon: "❌",
        message: locationError
      };
    }
    
    return {
      bgColor: "rgba(251, 191, 36, 0.1)",
      borderColor: "rgba(251, 191, 36, 0.3)",
      textColor: "#F59E0B",
      icon: "📍",
      message: "Location access needed to show nearby doctors"
    };
  };

  const config = getStatusConfig();
  const showButton = !userLocation && !isGettingLocation;

  return (
    <div
      style={{
        background: config.bgColor,
        border: `1px solid ${config.borderColor}`,
        borderRadius: "12px",
        padding: "12px 20px",
        margin: "20px auto",
        maxWidth: "800px",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
      }}
    >
      <div>
        <span style={{ color: config.textColor, fontSize: "14px" }}>
          {config.icon} {config.message}
        </span>
      </div>
      
      {showButton && (
        <button
          onClick={onEnableLocation}
          style={{
            background: "linear-gradient(135deg, #4F46E5, #7C3AED)",
            color: "white",
            border: "none",
            padding: "8px 16px",
            borderRadius: "20px",
            fontSize: "12px",
            fontWeight: "600",
            cursor: "pointer",
            transition: "all 0.3s ease"
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = "translateY(-1px)";
            e.target.style.boxShadow = "0 4px 12px rgba(79, 70, 229, 0.3)";
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = "translateY(0)";
            e.target.style.boxShadow = "none";
          }}
        >
          Enable Location
        </button>
      )}
    </div>
  );
};

export default LocationStatus;